
import { tedBio, robinBio } from './barneyBios'
import { tedReviewerReviewHinge, tedReviewerReviewBumble, robinReviewerReviewTinder } from './barneyReviewerReviews'

export const tedReviewerProfile = {
  _id: 'tedReviewerProfileId',
  userId: 'tedUserId',
  email: 'ted@email.com',
  profilePicture: 'https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ted-3.png',
  isVisible: true,
  isCoach: false,
  isAIReviewer: false,
  isHotty: true,
  isFeatured: false,
  reviewRate: 50,
  nameOfLLM: `NA`,
  openAIAssistantID: `NA`,
  bio: { ...tedBio },
  profileReviews: [
    // { ...tedProfileReviewHinge }
  ],
  reviewerReviews: [
    { ...tedReviewerReviewHinge },
    { ...tedReviewerReviewBumble }
  ],
}

export const robinReviewerProfile = {
  _id: 'robinReviewerProfileId',
  userId: 'robinUserId',
  email: 'robin@email.com',
  profilePicture: 'https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-robin-s-11-sq.png',
  isVisible: true,
  isCoach: false,
  isAIReviewer: false,
  isHotty: true,
  isFeatured: false,
  reviewRate: 50,
  nameOfLLM: `NA`,
  openAIAssistantID: `NA`,
  bio: { ...robinBio },
  profileReviews: [
    // { ...robinProfileReviewTinder }
  ],
  reviewerReviews: [
    { ...robinReviewerReviewTinder }
  ],
}